<template>
    <section class="text-center max-w-xl mx-auto pt-12">
        <BackButton :to="{ name: 'love-letter-prepare' }" />
        <Title class="ml-5">LoveLetter</Title>
        <Spinner v-if="!loaded" />
        <div v-else class="relative flex flex-col gap-y-2">
            <p class="text-lg"> Code: {{code}} </p>
            <p class="text-sm"> En attente de joueurs...</p>
            <div class="grid grid-cols-3 gap-3">
                <div v-for="player in players" :key="player.id">
                {{player.id}}
                </div>
            </div>
            <div class="flex mt-4 text-center">
                <button v-if="isLeader" class="w-full bg-gradient-to-r from-blue-400 to-blue-500 text-white font-bold py-4 px-4 rounded"
                    @click="StartNewRound">Démarrer</button>
            </div>
        </div>
    </section>
</template>
<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import Modal from '@/components/Modal'
export default {
    components: {
        Modal
    },
    data: () => ({
        loaded: false
    }),
    computed: {
        ...mapState('LoveLetter', ['code', 'username', 'game', 'players']),
        ...mapGetters('LoveLetter', ['isLeader'])
    },
    methods: {
        ...mapActions('LoveLetter', ['bindGame', 'bindPlayers', 'StartNewRound'])
    },
    mounted: async function () {
        if (this.code == null) return this.$router.push({ name: 'love-letter-prepare' })
        await this.bindGame();
        await this.bindPlayers();
        this.loaded = true
    },
    watch: {
        'game.status': {
            immediate: true,
            handler: function () {
                if (this.game && this.game.status == 'started') this.$router.push({ name: 'love-letter-play' })
            }
        }
    }
}
</script>